<template>
    <swiper
        :direction="vertical ? 'vertical' : 'horizontal'"
        :speed="Number(speed) || 300"
        :modules="modules"
        :slidesPerView="slidesPerView"
        :space-between="gap"
        :pagination="{
            dynamicBullets: true,
        }"
        @swiper="onSwiper"
    >
        <!-- @slideChange="onSlideChange" -->
        <slot></slot>
    </swiper>
  </template>
<script>
import { reactive, ref } from "vue"
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
// Import Swiper Vue.js components
import { Swiper } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

// SwiperCore.use([/* Swiper modules you need */]);

export default {
    name: 'v-swiper',
    emits: ['on-swiper'],
    components: {
        Swiper,
    },
    props: {
        gap: {
            type: [String, Number],
            default: 0
        },
        vertical: {
            type: Boolean,
            default: false
        },
        slidesPerView: {
            type: [String, Number],
            default: 'auto',
        },
        speed: {
            type: [String, Number],
            default: 300
        },
        slideIndex: {
            type: Number,
            default: 0
        },
    },
    methods: {
        onSwiper(swiper) {
            if (this.vertical) {
                this.loadedSwiper = swiper;
            } else {
                this.$emit('on-swiper', swiper);
            }
        }
    },
    data() {
        if (this.vertical != true) return {};

        return {
            loadedSwiper: {},
        }
    },
    watch: {
        slideIndex(newIndex) {
            console.log('newIndex', newIndex);
            if (this.loadedSwiper) this.loadedSwiper?.slideTo?.(newIndex)
        }
    },
    setup() {
        const lastPaginatinoClasses = reactive(ref(''))
        // const onSwiper = (swiper) => {
        //     console.log(swiper?.slideTo(1));
        // };
        // const onSlideChange = (event) => {
        //     console.log('slide change', event);
        // };
        return {
            // onSwiper,
            // onSlideChange,
            lastPaginatinoClasses,
            modules: [Navigation, Pagination, Scrollbar, A11y]
        };
    },
};
</script>

<style lang="scss">

.swiper {
    // width: 100%;
    // height: 100%;
}
.swiper-slide {

}

</style>